import Vue from "vue";

Vue.mixin({
  methods: {
    vueGroupBy(listOfObjects, attribute) {
      const map = new Map()
      listOfObjects.forEach((item) => {
        if (map.has(item[attribute])) {
          map.get(item[attribute]).push(item)
          map.set(item[attribute], map.get(item[attribute]))
        } else {
          map.set(item[attribute], [item])
        }
      })
      return Object.fromEntries(map)
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/groupBy.js